module.exports = __webpack_public_path__ + "media/images/lb/027-abfe5a9093416f7992d3e3aeddde5357.svg";